import Vue from 'vue'
import axios from 'axios'
import _ from 'underscore'
import router from '@/router'

const API = process.env.BASE_URL
const VERSION = process.env.VERSION

const config = {
  headers: {
    'Auth': 'skip'
  }
}

let configurationPromise = null
let configuration = {
  android: {}
}

export default {
  getConfiguration: function () {
    if (configurationPromise == null) {
      configurationPromise = axios.get(`${API}/configuration`, config).then(response => {
        _.extend(configuration, response.data)
        if (Vue.prototype.$mobileapp) {
          configuration.android.forceUpdate = configuration.android.minimumVersion > VERSION
          if (configuration.android.forceUpdate) {
            router.push('/mobile-application')
          }
        }
      })
      setTimeout(() => {
        configuration.android = {}
        configurationPromise = null
      }, 1000 * 60 * 10)
    }
    return configuration
  }
}
